import React from "react";
import "./ArticlesLoader.css";

interface ArticlesLoaderProps {
  message?: string;
  sub?: string;
}

/**
 * ArticlesLoader
 * A premium animated full-section loader displayed while article lists
 * are fetching from the server.  Drop-in replacement for any existing
 * spinner / skeleton inside article pages.
 *
 * Usage:
 *   {loading && <ArticlesLoader />}
 *   {loading && <ArticlesLoader message="Chargement des articles..." />}
 */
export default function ArticlesLoader({
  message = "Découvrez nos derniers articles",
  sub     = "Chargement en cours",
}: ArticlesLoaderProps) {
  return (
    <div className="articles-loader-backdrop" aria-busy="true" role="status">

      {/* ── Triple orbiting rings ── */}
      <div className="articles-loader-ring-wrap" aria-hidden="true">
        <div className="articles-loader-ring articles-loader-ring--outer" />
        <div className="articles-loader-ring articles-loader-ring--mid"   />
        <div className="articles-loader-ring articles-loader-ring--inner" />
        <div className="articles-loader-center-dot" />
      </div>

      {/* ── Text ── */}
      <div className="articles-loader-text-wrap">
        <span className="articles-loader-headline">{message}</span>
        <span className="articles-loader-sub">{sub}</span>
      </div>

      {/* ── Shimmer bar ── */}
      <div className="articles-loader-bar-track" aria-hidden="true">
        <div className="articles-loader-bar-fill" />
      </div>

      {/* ── Bounce dots ── */}
      <div className="articles-loader-dots" aria-hidden="true">
        <div className="articles-loader-dot" />
        <div className="articles-loader-dot" />
        <div className="articles-loader-dot" />
      </div>

    </div>
  );
}
